import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from 'dashboard/helper/inbox';

import facebookSvg from 'dashboard/assets/images/channels/facebook.svg';
import webchatSvg from 'dashboard/assets/images/channels/webchat.svg';
import whatsappBusinessSvg from 'dashboard/assets/images/channels/whatsapp_business.svg';
import whatsappCloudSvg from 'dashboard/assets/images/channels/whatsapp_cloud.svg';
import customChannelSvg from 'dashboard/assets/images/channels/custom_channel.svg';
import otherEmailSvg from 'dashboard/assets/images/channels/other_email.svg';
import smtpGmailSvg from 'dashboard/assets/images/channels/smtp_gmail.svg';
import twilioSvg from 'dashboard/assets/images/channels/twilio.svg';
import vonageSvg from 'dashboard/assets/images/channels/vonage.svg';
import telnyxSvg from 'dashboard/assets/images/channels/telnyx.svg';
import messageBirdSvg from 'dashboard/assets/images/channels/message_bird.svg';
import wechatSvg from 'dashboard/assets/images/channels/wechat.svg';
import instagramSvg from 'dashboard/assets/images/channels/instagram.svg';
import telegramSvg from 'dashboard/assets/images/channels/telegram.svg';
import lineSvg from 'dashboard/assets/images/channels/line.svg';
import tiktokSvg from 'dashboard/assets/images/channels/tiktok.svg';

/** @type {Record<string, string>} */
const SLUG_TO_URL = {
  facebook: facebookSvg,
  webchat: webchatSvg,
  whatsapp_business: whatsappBusinessSvg,
  whatsapp_cloud: whatsappCloudSvg,
  custom_channel: customChannelSvg,
  other_email: otherEmailSvg,
  smtp_gmail: smtpGmailSvg,
  twilio: twilioSvg,
  vonage: vonageSvg,
  telnyx: telnyxSvg,
  message_bird: messageBirdSvg,
  wechat: wechatSvg,
  instagram: instagramSvg,
  telegram: telegramSvg,
  line: lineSvg,
  tiktok: tiktokSvg,
};

/**
 * @param {string|null|undefined} slug - basename of `assets/images/channels/<slug>.svg`
 * @returns {string|null}
 */
export function getChannelSvgUrlExact(slug) {
  if (!slug || typeof slug !== 'string') return null;
  return SLUG_TO_URL[slug] ?? null;
}

/**
 * SVG URL for native-app / external echo rows when a channel asset exists.
 * Accepts both snake_case (channel_type) and camelCase (channelType) inbox shapes.
 * @param {{ channel_type?: string, channelType?: string, medium?: string, provider?: string }} inbox
 * @returns {string}
 */
export function getChannelSvgUrlForInbox(inbox) {
  const type = inbox?.channel_type || inbox?.channelType;
  if (!type) return '';

  const { medium, provider } = inbox;

  switch (type) {
    case INBOX_TYPES.FB:
      return SLUG_TO_URL.facebook;
    case INBOX_TYPES.WEB:
      return SLUG_TO_URL.webchat;
    case INBOX_TYPES.WHATSAPP:
      return SLUG_TO_URL.whatsapp_business;
    case INBOX_TYPES.WHATSAPP_BROWSER:
      return SLUG_TO_URL.whatsapp_business;
    case INBOX_TYPES.API:
      if (provider === 'waha_browser_whatsapp') {
        return SLUG_TO_URL.whatsapp_business;
      }
      return SLUG_TO_URL.custom_channel;
    case INBOX_TYPES.EMAIL:
      if (provider === 'google') return SLUG_TO_URL.smtp_gmail;
      return SLUG_TO_URL.other_email;
    case INBOX_TYPES.TWILIO:
      if (medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP) {
        return SLUG_TO_URL.whatsapp_business;
      }
      return SLUG_TO_URL.twilio;
    case INBOX_TYPES.TELEGRAM:
      return SLUG_TO_URL.telegram;
    case INBOX_TYPES.LINE:
      return SLUG_TO_URL.line;
    case INBOX_TYPES.INSTAGRAM:
      return SLUG_TO_URL.instagram;
    case INBOX_TYPES.TIKTOK:
      return SLUG_TO_URL.tiktok;
    default:
      return '';
  }
}
